<template>
  <div class="modal" v-bind:class="{ 'is-active': showmodalnit }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Crear Tercero</p>
        <button class="delete" @click="close" aria-label="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6">
            <label class="label">Nit</label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <input
                  v-model="datanit.codigo"
                  id="codigo"
                  class="input is-fullwidth"
                  type="text"
                  placeholder="Nit"
                  @keydown="keyNitFunc($event, 'tipo', 'tipo')"
                />
              </div>
              <p class="control">
                <a class="button is-static">{{ datanit.codigo | dverif() }}</a>
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <div class="control is-expanded">
                <label class="label">Tipo</label>
                <div class="select is-fullwidth">
                  <select
                    v-model="datanit.tipo"
                    id="tipo"
                    @keydown="keyNitFunc($event, 'nombre', 'nombre1')"
                  >
                    <option value="">Tipo</option>
                    <option value="Persona Jurídica">Persona Jurídica</option>
                    <option value="Persona Natural">Persona Natural</option>
                    <option value="Empresa Extranjera">
                      Empresa Extranjera
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">País</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    v-model="datanit.pais"
                    id="pais"
                    @keydown="keyNitFunc($event, 'guardar', 'guardar')"
                  >
                    <option v-for="(op, ind) in paises" :value="op" :key="ind">
                      {{ op.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column is-6"
            v-show="datanit.tipo !== 'Empresa Extranjera'"
          >
            <div class="field">
              <label class="label">Ciudad</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    v-model="datanit.ciudad"
                    id="ciudad"
                    @keydown="keyNitFunc($event, 'pais', 'pais')"
                  >
                    <option
                      v-for="(op, ind) in ciudades"
                      :value="op"
                      :key="ind"
                    >
                      {{ op.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6" v-show="datanit.tipo === 'Persona Natural'">
            <div class="field">
              <label class="label">Primer Nombre</label>
              <div class="control">
                <input
                  v-model="datanit.nombre1"
                  id="nombre1"
                  class="input"
                  type="text"
                  placeholder="Primer Nombre"
                  @keydown="keyNitFunc($event, 'nombre', 'nombre2')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6" v-show="datanit.tipo === 'Persona Natural'">
            <div class="field">
              <label class="label">Segundo Nombre</label>
              <div class="control">
                <input
                  v-model="datanit.nombre2"
                  id="nombre2"
                  class="input"
                  type="text"
                  placeholder="Segundo Nombre"
                  @keydown="keyNitFunc($event, 'nombre', 'apellido1')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6" v-show="datanit.tipo === 'Persona Natural'">
            <div class="field">
              <label class="label">Primer Apellido</label>
              <div class="control">
                <input
                  v-model="datanit.apellido1"
                  id="apellido1"
                  class="input"
                  type="text"
                  placeholder="Primer Apellido"
                  @keydown="keyNitFunc($event, 'nombre', 'apellido2')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6" v-show="datanit.tipo === 'Persona Natural'">
            <div class="field">
              <label class="label">Segundo Apellido</label>
              <div class="control">
                <input
                  v-model="datanit.apellido2"
                  id="apellido2"
                  class="input"
                  type="text"
                  placeholder="Segundo Apellido"
                  @keydown="keyNitFunc($event, 'nombre', 'nombre')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Razon Social</label>
              <div class="control">
                <input
                  v-model="datanit.nombre"
                  id="nombre"
                  class="input"
                  type="text"
                  placeholder="Razon Social"
                  @keydown="keyNitFunc($event, 'direccion', 'direccion')"
                />
              </div>
            </div>
          </div>
          <div
            class="column is-6"
            v-show="datanit.tipo !== 'Empresa Extranjera'"
          >
            <div class="field">
              <label class="label">Dirección</label>
              <div class="control">
                <input
                  v-model="datanit.direccion"
                  id="direccion"
                  class="input"
                  type="text"
                  placeholder="Dirección"
                  @keydown="keyNitFunc($event, 'telefono', 'telefono')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Teléfono</label>
              <div class="control">
                <input
                  v-model="datanit.telefono"
                  id="telefono"
                  class="input"
                  type="text"
                  placeholder="Teléfono"
                  @keydown="keyNitFunc($event, 'correo', 'correo')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Correo</label>
              <div class="control">
                <input
                  v-model="datanit.correo"
                  id="correo"
                  class="input"
                  type="email"
                  placeholder="@mail"
                  @keydown="keyNitFunc($event, 'ciudad', 'ciudad')"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Responsabilidades fiscales</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="datanit.regimen">
                    <option value="O-13">Gran Contribuyente</option>
                    <option value="O-15">Autorretenedor</option>
                    <option value="O-23">Agente de retención IVA</option>
                    <option value="O-47">Régimen simple de tributación</option>
                    <option value="O-23">No aplica - Otros</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Código postal</label>
              <div class="field">
                <div class="control is-expanded">
                  <input
                    v-model="datanit.postalcode"
                    class="input is-fullwidth"
                    type="text"
                    placeholder="Código postal"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label">Clasificación</label>
              <div class="control is-expanded">
                <div class="select is-fullwidth">
                  <select v-model="datanit.clase">
                    <option value="general">General</option>
                    <option value="cliente">Cliente</option>
                    <option value="proveedor">Proveedor</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div v-show="error" class="column is-12">
            <div class="notification is-danger">
              <button class="delete" @click="closeerror"></button>
              {{ error }}
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-info" @click="guardar" id="guardar">
          Guardar
        </button>
        <button class="button" @click="close">Cancelar</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      datanit: {
        codigo: null,
        tipo: "",
        nombre1: null,
        nombre2: null,
        apellido1: null,
        apellido2: null,
        nombre: null,
        direccion: null,
        telefono: null,
        correo: null,
        postalcode: null,
        regimen: null,
        ciudad: {},
        pais: {},
        namesearch: "",
        clase: "general",
      },
      error: null,
      ciudades: [],
      paises: [],
    };
  },
  computed: {
    ...mapState(["showmodalnit", "idtoken", "nits", "datamodalnit"]),
    tipo() {
      return this.datanit.tipo;
    },
  },
  methods: {
    guardar() {
      if (!this.datanit.codigo) {
        this.error = "Ingrese un código en el campo de Nit";
        return false;
      }
      if (this.datanit.tipo === "") {
        this.error = "Debe seleccionar un tipo";
        return false;
      }
      if (!this.datanit.nombre) {
        this.error = "Ingrese la Razon Social";
        return false;
      }
      if (!this.datanit.direccion) {
        this.error = "Debe ingresar la dirección";
        return false;
      }
      if (!this.datanit.correo) {
        this.error = "Ingrese el correo electrónico";
        return false;
      }
      if (!this.datanit.regimen) {
        this.error = "Debe seleccionar una responsabilidad fiscal";
        return false;
      }
      if (!this.datanit.postalcode) {
        this.error = "Debe indicar el código postal";
        return false;
      }

      if (this.datanit.tipo === "Empresa Extranjera") {
        this.datanit.ciudad = "";
      } else {
        this.datanit.ciudad = `${this.datanit.ciudad.codigo} - ${this.datanit.ciudad.nombre}`;
      }
      this.datanit.pais = `${this.datanit.pais.codigo} - ${this.datanit.pais.nombre}`;
      this.datanit.namesearch = this.datanit.nombre
        .concat(" ", this.datanit.codigo)
        .toLowerCase();
      this.error = null;
      this.guardaNit(this, this.datanit);
    },
    closeerror() {
      this.error = null;
    },
    async guardaNit(_this, data) {
      let result;
      try {
        result = await apiServices.post(`/nits`, data);
        if (result.data.existnit) {
          this.error = "El nit ya existe";
        } else {
          const nits = this.nits.map((e) => e);
          nits.push(result.data);
          _this.$store.commit("refreshNits", nits);
          this.close();
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema guardando el nit.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema guardando el nit", err);
      }
    },
    close() {
      this.datanit.codigo = null;
      this.datanit.tipo = null;
      this.datanit.nombre1 = null;
      this.datanit.nombre2 = null;
      this.datanit.apellido1 = null;
      this.datanit.apellido2 = null;
      this.datanit.nombre = null;
      this.datanit.direccion = null;
      this.datanit.telefono = null;
      this.datanit.correo = null;
      this.datanit.ciudad = null;
      this.datanit.pais = null;
      this.datanit.regimen = null;
      this.datanit.postalcode = null;
      this.datanit.clase = "general";
      this.error = null;
      this.$store.commit("launchModalnit");
    },
    keyNitFunc(event, a, d) {
      // a es el id de la celda la cual se dirige y d es la direccion si es persona natural
      if (event.keyCode === 13) {
        event.preventDefault();
        if (this.datanit.tipo === "Persona Natural") {
          document.getElementById(d).focus();
        } else {
          document.getElementById(a).focus();
        }
      }
    },
    async traeParametros(_this) {
      let result;
      try {
        result = await apiServices.get(`/parametros`);
        _this.ciudades = [];
        _this.paises = [];
        result.data.forEach(function (key, val) {
          if (key.codigo === 1) {
            const myObj = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.ciudades.push(myObj);
          } else {
            const myObj1 = {
              nombre: key.parametro.nombre,
              codigo: key.parametro.codigo,
            };
            _this.paises.push(myObj1);
          }
        });
        _this.ciudades.push({
          nombre: "Ciudad",
          codigo: "00",
        });
        _this.paises.push({
          nombre: "País",
          codigo: "00",
        });
        _this.ciudades = functions.order(_this.ciudades, "codigo");
        _this.paises = functions.order(_this.paises, "codigo");
        _this.datanit.ciudad = {
          nombre: "Ciudad",
          codigo: "00",
        };
        this.datanit.pais = {
          nombre: "País",
          codigo: "00",
        };
      } catch (err) {
        console.log("ocurrio un problema cargando las cuentas", err);
      }
    },
  },
  watch: {
    showmodalnit(nv, ov) {
      const _this = this;
      if (nv) {
        if (_this.ciudades.length === 0) {
          _this.traeParametros(_this);
        }
        setTimeout(function () {
          _this.datanit.codigo = _this.datamodalnit;
          document.getElementById("codigo").focus();
        }, 100);
      }
    },
    tipo(nv, ov) {
      if (nv === "Persona Jurídica" || nv === "Persona Natural") {
        this.datanit.pais = {
          codigo: "169",
          nombre: "Colombia",
        };
      } else {
        this.datanit.pais = {
          nombre: "País",
          codigo: "00",
        };
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/Nitmodal.vue